import React from 'react';
import { StarField } from './StarField';
import { AnimatedSection } from './AnimatedSection';
import { MoonIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center bg-night-900 overflow-hidden" data-id="element-88">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-20" style={{
      background: 'radial-gradient(circle, rgba(245,197,66,0.15) 0%, rgba(26,39,68,0.05) 60%, transparent 80%)'
    }} aria-hidden="true" data-id="element-89" />

      <StarField data-id="element-90" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-5 sm:px-8 py-16 md:py-24" data-id="element-91">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-92">
          {/* Text content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-93">
            <AnimatedSection data-id="element-94">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-night-700/60 border border-night-600/50 mb-8" data-id="element-95">
                <MoonIcon className="w-4 h-4 text-gold-400" data-id="element-96" />
                <span className="text-sm font-dm-sans text-cream-200 tracking-wide" data-id="element-97">
                  Método basado en cronobiología
                </span>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={100} data-id="element-98">
              <h1 className="font-playfair text-4xl sm:text-5xl md:text-[3.4rem] leading-[1.15] font-bold text-cream-100 mb-6" data-id="element-99">
                Por fin: El método exacto para que tu bebé{' '}
                <span className="text-gold-400 italic" data-id="element-100">
                  duerma toda la noche
                </span>{' '}
                <span className="text-cream-200/80" data-id="element-101">(sin dejarlo llorar)</span>
              </h1>
            </AnimatedSection>

            <AnimatedSection delay={200} data-id="element-102">
              <p className="font-dm-sans text-lg sm:text-xl text-cream-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-10" data-id="element-103">
                Recupera tu descanso y tu salud mental en solo{' '}
                <strong className="text-cream-100" data-id="element-104">7 días</strong> sincronizando
                el reloj biológico de tu hijo con el{' '}
                <strong className="text-gold-400" data-id="element-105">
                  Ritmo Natural del Sueño
                </strong>
                .
              </p>
            </AnimatedSection>

            <AnimatedSection delay={300} data-id="element-106">
              <a href="#oferta-compra" className="cta-glow inline-block px-10 py-4 bg-gold-400 hover:bg-gold-500 text-night-900 font-dm-sans font-bold text-lg rounded-xl transition-colors duration-300" aria-label="Quiero que mi bebé duerma ya — ir a la oferta" data-id="element-107">
                ¡QUIERO QUE MI BEBÉ DUERMA YA!
              </a>
              <p className="mt-4 text-sm text-cream-200/50 font-dm-sans" data-id="element-108">
                Pago seguro · Descarga inmediata
              </p>
            </AnimatedSection>
          </div>

          {/* Product image */}
          <AnimatedSection delay={200} className="flex-shrink-0" data-id="element-109">
            <div className="relative" data-id="element-110">
              {/* Glow behind image */}
              <div className="absolute inset-0 -m-8 rounded-3xl opacity-40" style={{
              background: 'radial-gradient(circle, rgba(245,197,66,0.2) 0%, transparent 70%)'
            }} aria-hidden="true" data-id="element-111" />
              <img src="https://cdn.magicpatterns.com/uploads/tpe1uDUP7iXWBFC3pBKqZb/heylloyd-image-1773529112244.png" alt="Método Noches en Paz — eBook mostrado en tablet con imagen de bebé durmiendo bajo la luna" className="relative w-72 sm:w-80 md:w-96 h-auto rounded-2xl shadow-2xl shadow-night-900/50" style={{
              animation: 'float 6s ease-in-out infinite'
            }} data-id="element-112" />
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32" style={{
      background: 'linear-gradient(to bottom, transparent, #131d35)'
    }} aria-hidden="true" data-id="element-113" />
    </section>;
}